import React, { useState, useEffect } from 'react'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { setInputmultiLanguageValue, valMax } from 'utils'
import InputWrapper from './InputWrapper'

const style = makeStyles(theme => ({
  textArea: {
    width: `100%`,
    height: `200px !important`,
    padding: theme.spacing(1.5),
    resize: `none`,
    border: `1px solid #7F8FA4`,
    borderRadius: 5,
    color: `black`,
    fontSize: theme.fontSize[1],
    '&:focus': {
      border: `1px solid #007BFF`,
      outline: `none !important`,
    },
  },
  valid: {
    borderRadius: 5,
    border: `1px solid #007BFF`,
  },
  error: {
    border: `1px solid ${theme.palette.error.main}`,
  },
  viewMode: {
    color: `black`,
    border: `none`,
    background: `transparent`,
    padding: theme.spacing(1.5, 0),
    '& > input': {
      background: `transparent`,
    },
  },
  textWarning: {
    color: `#FF5252`,
  },
  textRight: {
    display: `block`,
    textAlign: `right`,
  },
}))

export default function TextAreaWrapper({
  id,
  label,
  error,
  isRequired = false,
  onChange,
  onBlur,
  isValid,
  value,
  id: name,
  placeholder,
  disabled = false,
  align = `left`,
  md = 12,
  xs = 12,
  rows = 4,
  rowsMax = 10,
  multiLanguage = false,
  languageKey = ``,
  viewMode = false,
  showCounter = false,
  rules: { min = 0, max, useFormValue = false, required = false } = {},
  rules,
  maxMessage = `Se ha alcanzado el máximo de caracteres permitido`,
  useOnChangeInsteadOnBlur = false,
  ...rest
}) {
  const classes = style()
  const [localValue, setLocalValue] = useState(multiLanguage ? value[languageKey] : value)
  const isMaxCounter = max && (localValue ? localValue.length : 0) >= max
  const props = {
    rowsMax,
    rows,
    placeholder,
    id,
    name,
    disabled,
    autoFocus: false,
    'aria-label': `maximum height`,
    className: `${classes.textArea} ${isValid ? classes.valid : ``} ${
      viewMode ? classes.viewMode : ``
    } ${error ? classes.error : ``}`,
    onKeyUp: ({ target: { value } }) => handleKeyUpValue(value),
    ...(useFormValue
      ? {
          value: multiLanguage ? value[languageKey] : value,
        }
      : {
          defaultValue: localValue,
        }),
    ...(useOnChangeInsteadOnBlur
      ? {
          onChange: ({ target: { value, name } }) => handleNewValue(value, name),
        }
      : {
          onBlur: ({ target: { value, name } }) => handleNewValue(value, name),
        }),
  }

  function handleNewValue(nextValue, name) {
    value = multiLanguage
      ? setInputmultiLanguageValue({
          languageKey,
          value: {
            current: value,
            next: nextValue,
          },
        })
      : nextValue
    const listenFunction = useOnChangeInsteadOnBlur ? onChange : onBlur
    return listenFunction({
      name,
      value,
      id,
      languageKey,
    })
  }

  function handleKeyUpValue(value) {
    if (valMax(value, max)) {
      handleNewValue(value.slice(0, max), id)
    } else {
      setLocalValue(isMaxCounter ? localValue : value)
    }
  }

  useEffect(() => {
    if (useFormValue) {
      setLocalValue(value)
    }
  }, [value, useFormValue])

  return (
    <InputWrapper
      label={label}
      isRequired={isRequired || required}
      align={align}
      error={error}
      md={md}
      xs={xs}
      disabled={disabled}
      languageKey={languageKey}
      {...rest}
    >
      <TextareaAutosize {...props} />
      {showCounter && (
        <Grid container direction="row" justify="space-between" alignItems="flex-start">
          <Grid item xs={10}>
            {isMaxCounter && (
              <Typography variant="caption" className={classes.textWarning}>
                {maxMessage}
              </Typography>
            )}
          </Grid>
          <Grid item xs={2}>
            <Typography variant="caption" className={classes.textRight}>
              {max && localValue ? max - localValue.length : max}
            </Typography>
          </Grid>
        </Grid>
      )}
    </InputWrapper>
  )
}
